import { useState } from "react";
import { ChevronsLeftRight } from "lucide-react";
import { IMAGES } from "../lib/constants";

export const BeforeAfter = ({ before = IMAGES.hero, after = IMAGES.kitchen, genuine = false }) => {
  const [pos, setPos] = useState(50);
  return (
    <div data-testid="before-after-slider" className="relative aspect-[16/10] w-full select-none overflow-hidden rounded-2xl shadow-xl">
      <img src={after} alt={genuine ? "Completed KAC project — after" : "Illustrative after renovation visual"} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={genuine ? "KAC project — before work began" : "Illustrative before renovation visual"} className={`absolute inset-0 h-full w-full object-cover ${genuine ? "" : "grayscale-[0.4]"}`} />
      </div>
      <div className="absolute inset-y-0 w-0.5 bg-white" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-brand-green shadow-lg">
          <ChevronsLeftRight className="h-5 w-5" />
        </div>
      </div>
      <span className="absolute left-3 top-3 rounded-full bg-brand-ink/60 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white">Before</span>
      <span className="absolute right-3 top-3 rounded-full bg-brand-red px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-white">After</span>
      {genuine && (
        <span className="absolute bottom-3 left-3 rounded-full bg-brand-green px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white">Genuine KAC work</span>
      )}
      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        data-testid="before-after-range"
        aria-label="Drag to compare before and after"
        className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0"
      />
    </div>
  );
};
